module.exports = __webpack_public_path__ + "img/notification-bing.cec9460c.svg";